import { EditorView, basicSetup } from 'codemirror';
import { css } from '@codemirror/lang-css';

export function initEditor(textarea) {
  if (!textarea) return;

  textarea.style.display = 'none';

  const editor = new EditorView({
    doc: textarea.value,
    extensions: [basicSetup, css()],
    parent: document.querySelector('#js-twer-editor'),
  });

  const { form } = textarea;

  if (form) {
    form.addEventListener('submit', () => {
      textarea.value = editor.state.doc.toString();
    });
  }
}
